import { Base } from "ui/Scripts/source/framework/base";
import { ITaskEditItemTaskState, TaskEditItemTaskState } from "./taskEditItemTaskState";
import { ITaskEditItemTaskPriority, TaskEditItemTaskPriority } from "./taskEditItemTaskPriority";

export interface ITaskEditTaskTypeData {
    taskStates: ITaskEditItemTaskState[];
    taskPriorities: ITaskEditItemTaskPriority[];
    taskTypeUnitIds: string[];
}

export class TaskEditTaskTypeData implements ITaskEditTaskTypeData {
    taskStates: TaskEditItemTaskState[];
    taskPriorities: TaskEditItemTaskPriority[];
    taskTypeUnitIds: string[];

    constructor();
    constructor(obj: ITaskEditTaskTypeData);
    constructor(obj?: any) {
        this.taskStates = Base.getTypedArray(obj?.taskStates, TaskEditItemTaskState);
        this.taskPriorities = Base.getTypedArray(obj?.taskPriorities, TaskEditItemTaskPriority);
        this.taskTypeUnitIds = obj?.taskTypeUnitIds ?? [];
    }
}